export function validateCandleTrigger(data) {
  const { tradePlan, candleDuration } = data;
  if (tradePlan.entryTactics?.CANDLE_BREAK) {
    if (tradePlan.entryTactics?.CANDLE_BREAK?.waitUntilCurrentCandleCloses) {
      return [
        false,
        'Wait for Candle Close cannot be selected on entry when using Candle Trigger setup.',
      ];
    }
  }
  if (!candleDuration || candleDuration <= 0)
    return [false, 'You must enter a candle duration larger than 0'];
  if (!Number.isInteger(candleDuration))
    return [false, 'Candle Duration must be a whole number.'];
  return [true, ''];
}
